import { throttle } from 'throttle-debounce';

export default class AdState {
  constructor() {
    this.priorities = {
      'squeeze_frame': 4,
      'superimpose': 3,
      'ticker_tape': 2,
      'pause': 1,
      'overlay': 0,
    }

    this._shownAd = null
    this._hideFunction = () => {}

    this.generateThrottledFunc()
  }

  tryResetShownAd(wantToRemove) {
    if(this.shownAd === wantToRemove) {
      this.setShownAd(null)
      this.setHideFunction(() => {})
    }
  }

  generateThrottledFunc() {
    this.tryUpdateShownAd = throttle(1000, this.tryShowAd)
  }

  tryShowAd(wantToShow, showFunction, hideFunction) {
    if (this.shouldUpdateShownAd(wantToShow)) {
      this.hideFunction();

      showFunction();

      this.setShownAd(wantToShow)
      this.setHideFunction(hideFunction)
    }
  }

  shouldUpdateShownAd(wantToShow) {
    if (this.shownAd == null) {
      return true
    }

    return this.priorities[wantToShow] >= this.priorities[this.shownAd]
  }

  setShownAd(value) {
    this._shownAd = value
  }

  setHideFunction(value) {
    this._hideFunction = value
  }

  get shownAd() {
    return this._shownAd
  }

  get hideFunction() {
    return this._hideFunction
  }
}